import React from 'react';
import { Link } from 'react-router-dom';
import LandingTemplate from '../LandingTemplate';

export default function ConfirmEmailSuccess() {
  return <LandingTemplate>
    Your email is confirmed! Please <Link to="/login">Login</Link> to start using our app.
  </LandingTemplate>
}